import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

// Custom Modules
import { ComponentsModule } from '../components/components.module';
import { CoreModule } from '../../core/core.module';

import { TermsAndConditionsPage } from './terms-and-conditions/terms-and-conditions.page';
import { OrientationPage } from './orientation/orientation.page';

const MODALS = [TermsAndConditionsPage, OrientationPage];

@NgModule({
  declarations: [TermsAndConditionsPage, OrientationPage],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule.forChild(),

    // Custom Modules
    ComponentsModule,
    CoreModule,
  ],
  exports: MODALS,
})
export class ModalsModule {}
